import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// core components
import Visibility from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';

const styles = theme => ({
  tableHeadCell: {
    color: '#284860'
  },
  tableResponsive: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  }
});

const CustomTable = ({ classes, tableHead, tableData, tableFilter }) => {
  var apps = [];

  tableData.forEach(application => {
    const filter = application.validationPass;
    if (filter === tableFilter) {
      apps.push(application);
    }
  });
  const tableRows = apps.map((prop, key) => {
    const path = `/admin/Validation/Logs/${prop.applicationName}`;
    return (
      <TableRow key={prop.applicationName} className={classes.tableRow}>
        <TableCell className={classes.tableCell}>
          {prop.applicationName}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {prop.validationPass}
        </TableCell>
        <TableCell className={classes.tableCell}>{prop.time}</TableCell>
        <TableCell className={classes.tableCell}>
          <Link component={RouterLink} to={path}>
            <IconButton>
              <Visibility />
            </IconButton>
          </Link>
        </TableCell>
      </TableRow>
    );
  });

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + ' ' + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>{tableRows}</TableBody>
      </Table>
    </div>
  );
};

export default withStyles(styles)(CustomTable);
